// Gravity Forms GA4 tracking: pushes the `gform_submission` data layer event
// for the confirmations only the browser can detect — AJAX confirmations and
// redirect landings. Text/page confirmations push server-side via an inline
// script (components/class-form-tracking.php); the shared window.acatoGfTracked
// guard keeps any combination of paths from pushing the same form twice.

const push = (formId, formName) => {
	const id = parseInt(formId, 10);

	if (!id) {
		return;
	}

	window.acatoGfTracked = window.acatoGfTracked || {};

	if (window.acatoGfTracked[id]) {
		return;
	}

	window.acatoGfTracked[id] = true;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event: 'gform_submission', form_id: id, form_name: formName || '' });
};

export default function formTracking() {
	// AJAX confirmations (jQuery-only Gravity Forms event).
	if (window.jQuery) {
		window.jQuery(document).on('gform_confirmation_loaded', (event, formId) => push(formId, ''));
	}

	// Redirect confirmations land here with query args appended server-side.
	const params = new URLSearchParams(window.location.search);

	if (params.has('gf_submitted')) {
		push(params.get('gf_submitted'), params.get('gf_name') || '');
		params.delete('gf_submitted');
		params.delete('gf_name');
		const query = params.toString();
		window.history.replaceState(null, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
	}
}
